import { render, staticRenderFns } from "./ProgramScreenCastsCard.vue?vue&type=template&id=21adc2ba"
import script from "./ProgramScreenCastsCard.vue?vue&type=script&lang=ts"
export * from "./ProgramScreenCastsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports